import { ServiceConfig } from '../services/types';

const CS1_STORE_ID = 'CS1';
const PRODUCT_CARE_LOCATION = 'Kerrville';

const splitLocations = (locations: string[] = []): string[] =>
  locations
    .flatMap((loc) => String(loc).split(',').map((value) => value.trim()))
    .filter(Boolean);

const arraysEqual = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((value, index) => value === b[index]);

const sortKey = (config: ServiceConfig | null | undefined): number => {
  if (!config) return Number.POSITIVE_INFINITY;
  const order = config.sortOrder;
  if (typeof order === 'number' && Number.isFinite(order)) {
    return order;
  }
  return Number.POSITIVE_INFINITY;
};

export const compareServiceConfigs = (a: ServiceConfig, b: ServiceConfig): number => {
  const aKey = sortKey(a);
  const bKey = sortKey(b);
  if (aKey !== bKey) {
    return aKey - bKey;
  }
  return a.sku.localeCompare(b.sku, 'en', { sensitivity: 'base' });
};

export const sortServiceConfigs = <T extends ServiceConfig>(configs: T[] = []): T[] =>
  [...configs].sort(compareServiceConfigs);

export const applyCs1ProductCareOverrides = <T extends ServiceConfig>(
  configs: T[] = [],
  storeId?: string,
): T[] => {
  if (!storeId || storeId.toUpperCase() !== CS1_STORE_ID) {
    return configs;
  }

  return configs.map((config) => {
    const existing = config.locationServiced ?? [];
    const tokens = splitLocations(existing);
    if (!tokens.length) {
      return config;
    }

    const nextLocations = [PRODUCT_CARE_LOCATION];
    if (arraysEqual(existing, nextLocations)) {
      return config;
    }

    return {
      ...config,
      locationServiced: nextLocations,
    };
  });
};
